module.exports = __webpack_public_path__ + "static/media/CO2.6d01f353.svg";